import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Moon, Sun } from 'lucide-react';
import { Button } from './button';

export function ThemeToggle({ variant = 'ghost', size = 'icon', className = '' }) {
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggleTheme}
      className={className}
      data-testid="theme-toggle"
      aria-label={isDark ? 'Passa al tema chiaro' : 'Passa al tema scuro'}
    >
      {isDark ? (
        <Sun className="w-5 h-5 transition-transform hover:rotate-45" />
      ) : (
        <Moon className="w-5 h-5 transition-transform hover:-rotate-12" />
      )}
    </Button>
  );
}

export default ThemeToggle;
